import { Link } from "react-router-dom";
import homeIcon from "@assets/images/vuesax-bold-home-2@2x.png";
import cardIcon from "@assets/images/vuesax-bold-card@2x.png";
import serviceIcon from "@assets/images/Vector.svg";
import searchIcon from "@assets/images/vuesax-bold-search-normal@2x.png";
import mobileIcon from "@assets/images/vuesax-bold-mobile@2x.png";

/* ───────────────────────────────────────────────────────── */

interface QuickLinkCardProps {
  icon: string;
  label: string;
  to: string;
}

function QuickLinkCard({ icon, label, to }: QuickLinkCardProps) {
  return (
    <Link
      to={to}
      className="flex-1 min-w-[140px] rounded-[24px] bg-white flex flex-col items-center justify-center gap-6 p-6 md:py-10 hover:shadow-md transition-shadow no-underline"
    >
      <img src={icon} alt="" className="w-10 h-10 md:w-14 md:h-14 object-contain" />
      <span className="text-[18px] md:text-[24px] tracking-[-0.04em] font-semibold text-[#090d2c] font-albert-sans text-center">
        {label}
      </span>
    </Link>
  );
}

/* ───────────────────────────────────────────────────────── */

const quickLinks = [
  { icon: homeIcon, label: "Back to Home", to: "/" },
  { icon: cardIcon, label: "Pay Bill", to: "/services/pay-bill" },
  { icon: serviceIcon, label: "Submit Service Request", to: "/contact" },
  { icon: searchIcon, label: "Search GAZ Website", to: "/" },
  { icon: mobileIcon, label: "Download Our Mobile App", to: "/" },
];

export function QuickLinksSection() {
  return (
    <section className="w-full bg-[#f1f1f1] overflow-hidden">
      <div className="w-full max-w-[1728px] mx-auto flex flex-col items-center pt-12 md:pt-16 lg:pt-[60px] px-4 md:px-8 lg:px-[30px] pb-16 lg:pb-[72px]">
        {/* Title */}
        <h2 className="text-[36px] md:text-[48px] lg:text-[60px] tracking-[-0.04em] font-semibold text-[#122d63] font-albert-sans text-center">
          Quick Links
        </h2>

        {/* Cards Grid */}
        <div className="w-full max-w-[1368px] grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6 py-8 md:py-12">
          {quickLinks.map((link) => (
            <QuickLinkCard key={link.label} {...link} />
          ))}
        </div>
      </div>
    </section>
  );
}
